import type { ParcelleListItem } from "../pages/vignoble/ParcellesList.js";

/** Année et géométrie changent la projection, jamais le périmètre de la liste. */
function estLectureComplete(input: unknown): boolean {
  if (input === undefined || input === null) return true;
  if (typeof input !== "object" || Array.isArray(input)) return false;
  if (Object.getPrototypeOf(input) !== Object.prototype) return false;
  return Object.entries(input).every(([cle, valeur]) => {
    if (cle === "annee_reference")
      return (
        valeur === undefined ||
        (typeof valeur === "number" && Number.isInteger(valeur) && valeur >= 1900 && valeur <= 9999)
      );
    if (cle === "inclure_polygone") return valeur === undefined || typeof valeur === "boolean";
    if (cle === "recherche_lieudit")
      return valeur === undefined || (typeof valeur === "string" && valeur.trim() === "");
    if (cle === "statut" || cle === "cepage_id" || cle === "cru") return valeur === undefined;
    // Un futur filtre inconnu ne doit jamais amputer le cache complet.
    return false;
  });
}

/** Le tenant est celui de la requête réussie, pas celui actif à sa résolution. */
export async function actualiserCacheParcellesApresLecture(
  queryKey: readonly unknown[],
  data: unknown,
  ecrire: (domaineId: string, parcelles: ParcelleListItem[]) => Promise<void>,
): Promise<void> {
  const [scope, domaineId, procedure, input] = queryKey;
  if (queryKey.length > 4 || scope !== "tenant" || procedure !== "parcellaire.lister") return;
  if (typeof domaineId !== "string" || domaineId.trim() === "") return;
  if (!estLectureComplete(input) || !Array.isArray(data)) return;
  await ecrire(domaineId, data as ParcelleListItem[]);
}
